var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgLoading = function SvgSvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.247a.75.75 0 0 1-.75-.75V.747a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75zm0 18.75a.75.75 0 0 1-.75-.75v-3.75a.75.75 0 0 1 1.5 0v3.75a.75.75 0 0 1-.75.75zM6.697 7.444a.743.743 0 0 1-.53-.22L3.515 4.572a.744.744 0 0 1 0-1.06.743.743 0 0 1 .53-.22c.2 0 .389.078.53.22l2.652 2.652a.744.744 0 0 1 0 1.06.743.743 0 0 1-.53.22zm13.258 13.258a.743.743 0 0 1-.53-.22l-2.652-2.651a.743.743 0 0 1-.22-.53.749.749 0 0 1 1.28-.53l2.652 2.651c.142.141.22.33.22.53s-.078.389-.22.53a.749.749 0 0 1-.53.22zM.75 12.747a.75.75 0 0 1 0-1.5H4.5a.75.75 0 0 1 0 1.5H.75zm18.75 0a.75.75 0 0 1 0-1.5h3.75a.75.75 0 0 1 0 1.5H19.5zM4.045 20.702a.743.743 0 0 1-.53-.22.745.745 0 0 1-.22-.531c0-.201.078-.389.22-.53l2.652-2.651a.744.744 0 0 1 1.06 0c.142.142.22.33.22.531a.741.741 0 0 1-.22.53l-2.652 2.651a.743.743 0 0 1-.53.22zM17.303 7.444a.743.743 0 0 1-.53-.22.743.743 0 0 1-.22-.53c0-.2.078-.389.22-.53l2.652-2.652a.744.744 0 0 1 1.06 0c.142.141.22.33.22.53s-.078.389-.22.53l-2.652 2.652a.743.743 0 0 1-.53.22z",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 12 12;360 12 12",
    keyTimes: "0;1",
    dur: "2s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
};
export default SvgSvgLoading;